import { css } from "@emotion/react";
import React from "react";
import defaultIcon from "../../assets/default-icon.png";

export default function ShowIcon({ showImageUrl, large, ...props }) {
    return (
        <img
            className="show-icon"
            onError={event => (event.target.src = defaultIcon)}
            src={showImageUrl || defaultIcon}
            css={css`
                width: ${large ? 3 : 1.5}rem;
                height: ${large ? 3 : 1.5}rem;
                max-width: ${large ? 3 : 1.5}rem;
                border: 1px solid var(--border-color-low-contrast);
                background-color: var(--border-color-low-contrast);
                margin-top: -0.5rem;
                margin-bottom: -0.5rem;
                margin-right: ${large ? 0.5 : 0.25}rem;
                flex-shrink: 0;
            `}
            {...props}
        />
    );
}
